/**
 * Cross Bundle (Set Builder) app: Theme-Anpassungen.
 * Geladen vom Block "SH - Cross Bundle" in sh-main-product.
 *
 *   1. Drawer: Karten mit Menge > 0 bekommen .bbb-selected
 *   2. Preisblock: ersetzt den App-Preis durch den Theme-Preisblock (.shbp)
 *   3. Drawer: Fragezeichen-Button pro Karte öffnet das Produkt-Popup (Quick-View wie beim Lieferumfang)
 */

/* 1. Drawer */
(function () {
  // markiert Karten mit Menge > 0 als ausgewählt
  var queued = false;
  function sync() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      document.querySelectorAll('.crossbundle-drawer .crossbundle-product-card').forEach(function (card) {
        var input = card.querySelector('.crossbundle-product-card__quantity-input');
        var on = !!input && parseInt(input.value, 10) > 0;
        if (card.classList.contains('bbb-selected') !== on) card.classList.toggle('bbb-selected', on);
      });
    });
  }
  function init() {
    sync();
    document.addEventListener('click', function () { setTimeout(sync, 50); }, true);
    document.addEventListener('input', sync, true);
    document.addEventListener('change', sync, true);
    new MutationObserver(sync).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['value', 'class'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* 2. Preisblock */
(function () {
  var config = document.querySelector('[data-sh-crossbundle]');
  var LABEL_SALE = (config && config.dataset.priceLabel) || 'Dein Bundlepreis';
  var ICON_GIFT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7M7.5 8a2.5 2.5 0 0 1 0-5C10 3 12 8 12 8s2-5 4.5-5a2.5 2.5 0 0 1 0 5"/></svg>';

  function parse(t) {
    if (!t) return NaN;
    t = t.replace(/[^\d.,]/g, '');
    if (t.indexOf(',') > -1) t = t.replace(/\./g, '').replace(',', '.');
    return parseFloat(t);
  }
  function fmt(n) {
    var s = n.toFixed(2).replace('.', ',');
    return s.replace(/,00$/, '') + '€';
  }
  function txt(root, sel) {
    var el = root.querySelector(sel);
    return el ? el.textContent.trim() : '';
  }

  function giftInfo(scope) {
    var count = 0, value = 0;
    scope.querySelectorAll('.crossbundle-picker-card--filled').forEach(function (c) {
      if (c.offsetParent === null) return;
      if (!/gratis/i.test(txt(c, '.crossbundle-picker-card__badge'))) return;
      var v = parse(txt(c, '.crossbundle-picker-card__price-compare'));
      if (isNaN(v)) v = parse(txt(c, '.crossbundle-picker-card__price'));
      if (!isNaN(v) && v > 0) { value += v; count++; }
    });
    return { count: count, value: value };
  }

  function render(src) {
    var block = src.nextElementSibling;
    if (!block || !block.classList.contains('shbp')) {
      block = document.createElement('div');
      block.className = 'shbp';
      src.insertAdjacentElement('afterend', block);
    }
    if (!src.classList.contains('shbp-src')) src.classList.add('shbp-src');

    var scope = src.closest('.sh-buybox-wrapper, form, section') || document;
    var incomplete = Array.prototype.some.call(
      scope.querySelectorAll('.crossbundle-picker-card--empty'),
      function (c) { return c.offsetParent !== null; }
    );

    var content = src.querySelector('.crossbundle-price__content');
    var price = parse(txt(src, '.crossbundle-price__price'));
    var compare = parse(txt(src, '.crossbundle-price__compare'));
    if (incomplete || !content || getComputedStyle(content).display === 'none' || isNaN(price)) {
      block.hidden = true;
      return;
    }
    block.hidden = false;

    var hasCompare = !isNaN(compare) && compare > price;
    var save = hasCompare ? compare - price : 0;
    var gift = giftInfo(scope);

    var html = '';
    if (hasCompare || gift.value > 0) {
      html += '<div class="shbp__calc">';
      if (hasCompare) html += '<span>Einzeln <s>' + fmt(compare) + '</s></span>';
      if (hasCompare && gift.value > 0) html += '<span class="shbp__calc-sep"></span>';
      if (gift.value > 0) {
        html += '<span class="shbp__gift">' + ICON_GIFT +
                (gift.count === 1 ? 'Gratis Produkt' : gift.count + ' Gratis Produkte') +
                ' −' + fmt(gift.value) + '</span>';
      }
      html += '</div>';
    }

    html += '<div class="shbp__main"><div class="shbp__price">' +
            '<span class="shbp__label">' + LABEL_SALE + '</span>' +
            '<span class="shbp__value">' + fmt(price) + '</span></div>';
    if (save >= 0.5) {
      html += '<div class="shbp__savings"><span class="shbp__savings-dot"></span>' +
              '<span>Du sparst ' + fmt(save) + '</span></div>';
    }
    html += '</div>';

    if (block.innerHTML !== html) block.innerHTML = html;
  }

  var queued = false;
  function update() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      document.querySelectorAll('.crossbundle-price-container').forEach(render);
    });
  }

  function init() {
    update();
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        var el = t.nodeType === 1 ? t : t.parentElement;
        if (el && el.closest && el.closest('.shbp')) continue;
        update();
        return;
      }
    }).observe(document.body, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class', 'style'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* 3. Fragezeichen-Button im Drawer */
(function () {
  var requests = {};

  // sh-pre-order.js öffnet den Quick-View (Slider etc.). Nur nachladen, wenn er fehlt,
  // sonst hängt der Listener doppelt.
  function ensurePreOrderAssets() {
    if (document.querySelector('script[src*="sh-pre-order.js"]')) return Promise.resolve();
    var cfg = document.querySelector('[data-sh-crossbundle]');
    if (!cfg) return Promise.resolve();
    var css = document.createElement('link');
    css.rel = 'stylesheet';
    css.href = cfg.dataset.preOrderCss;
    document.head.appendChild(css);
    return new Promise(function (resolve) {
      var script = document.createElement('script');
      script.src = cfg.dataset.preOrderJs;
      script.onload = resolve;
      script.onerror = resolve;
      document.head.appendChild(script);
    });
  }

  function ensureQuickview(handle, modalId) {
    var existing = document.getElementById(modalId);
    if (existing) return Promise.resolve(existing);
    if (requests[modalId]) return requests[modalId];
    requests[modalId] = fetch('/products/' + encodeURIComponent(handle) + '?view=lfu-quickview')
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var holder = document.createElement('div');
        holder.innerHTML = html;
        var modal = holder.querySelector('modal-dialog');
        if (!modal) return null;
        var already = document.getElementById(modalId) || document.getElementById(modal.id);
        if (already) { already.id = modalId; return already; }
        modal.id = modalId;
        document.body.appendChild(modal);
        return modal;
      })
      .finally(function () { delete requests[modalId]; });
    return requests[modalId];
  }

  function addButtons() {
    document.querySelectorAll('.crossbundle-drawer .crossbundle-product-card[data-product-handle]').forEach(function (card) {
      if (card.querySelector('.sh-cb-info')) return;
      var box = card.querySelector('.crossbundle-product-card__box') || card;
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'sh-cb-info';
      button.setAttribute('aria-label', 'Mehr Infos zum Produkt');
      button.setAttribute('aria-haspopup', 'dialog');
      button.innerHTML = '<span aria-hidden="true">?</span>';
      box.appendChild(button);
    });
  }

  // Capture-Phase: Klick aufs Fragezeichen darf die Karte nicht auswählen.
  ['pointerdown', 'mousedown', 'touchstart', 'pointerup', 'mouseup'].forEach(function (type) {
    document.addEventListener(type, function (event) {
      if (event.target.closest && event.target.closest('.sh-cb-info')) event.stopPropagation();
    }, true);
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('.sh-cb-info');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    var card = button.closest('.crossbundle-product-card');
    var handle = card && card.dataset.productHandle;
    if (!handle) return;
    var modalId = 'sh-lfu-qv-' + card.dataset.productId;
    button.classList.add('is-loading');
    Promise.all([ensurePreOrderAssets(), ensureQuickview(handle, modalId)])
      .then(function (result) {
        var modal = result[1];
        if (!modal) return;
        document.dispatchEvent(new CustomEvent('sh:lfu:qv-open', { detail: { modal: modal, opener: button } }));
      })
      .finally(function () { button.classList.remove('is-loading'); });
  }, true);

  var queued = false;
  function update() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; addButtons(); });
  }

  function init() {
    update();
    new MutationObserver(update).observe(document.body, { subtree: true, childList: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
